module.exports = __webpack_public_path__ + "img/sec1_4.efb67655.png";